export const finishesData = [
  //#region demo
  {
    id: "demo",
    color: 0xffffff, //optional
    diffuseUrl: "textures/_common/body_diffuse_bronze_textures.jpg", //optional
    normalUrl: "textures/_common/body_paint_normal.jpg", //optional
    ormUrl: "textures/_common/body_paint_orm.png", //optional
    repeat: [10, 10], //optional
    normalRepeat: [10, 10], //optional
    ormRepeat: [10, 10], //optional
    useAo: false, //optional default false
    useRoughness: false, //optional default false
    useMetallicness: false, //optional default false
  },
  //endregion

  //#region white
  {
    id: "white paint",
    color: 0xffffff,
    // diffuseUrl: "textures/fabric01_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.5,
    mettalicness: 0.2,
    normalScale: 0.1,
  },
  //endregion

  //#region grey
  {
    id: "gray paint",
    color: 0x333333,
    // diffuseUrl: "textures/fabric01_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.125,
    mettalicness: 1,
    normalScale: 0.1,
  },
  //endregion

  //#region brass
  {
    id: "brass paint",
    color: 0xC0C0C0,
    // diffuseUrl: "textures/fabric01_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.125,
    mettalicness: 1,
    normalScale: 0.1,
  },
  //endregion

  //#region black
  {
    id: "black paint",
    color: 0x000000,
    // diffuseUrl: "textures/fabric01_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.75,
    mettalicness: 0,
    normalScale: 0.1,
  },
  //endregion

  //#region satin nickel
  {
    id: "satin nickel",
    color: 0xe1c16e,
    // diffuseUrl: "textures/fabric01_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.75,
    mettalicness: 0,
    normalScale: 0.1,
  },
  //endregion

  //#region painted
  {
    id: "painted",
    color: 0xe1c16e,
    // diffuseUrl: "textures/fabric01_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.75,
    mettalicness: 0,
    normalScale: 1,
  },
  //endregion

  //#region Bricks
  {
    id: "Bricks",
    // color: 0xe1c16e,
    diffuseUrl: "textures/apartment_brick_diffuse.jpg",
    normalUrl: "textures/apartment_brick_normal.jpg",
    repeat: [2, 2],
    normalRepeat: [2, 2],
    roughnessRepeat: [2, 2],
    mettalicnessRepeat: [2, 2],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.75,
    mettalicness: 0,
    normalScale: 1,
  },
  //endregion

  //#region Concrete1
  {
    id: "Concrete1",
    // color: 0xe1c16e,
    diffuseUrl: "textures/apartment_concrete1_diffuse.jpg",
    normalUrl: "textures/apartment_concrete1_normal.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [2, 2],
    normalRepeat: [2, 2],
    roughnessRepeat: [2, 2],
    mettalicnessRepeat: [2, 2],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.75,
    mettalicness: 0,
    normalScale: 1,
  },
  //endregion

  //#region Concrete2
  {
    id: "Concrete2",
    // color: 0xe1c16e,
    diffuseUrl: "textures/apartment_concrete2_diffuse.jpg",
    normalUrl: "textures/apartment_concrete2_normal.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [2, 2],
    normalRepeat: [2, 2],
    roughnessRepeat: [2, 2],
    mettalicnessRepeat: [2, 2],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 0.75,
    mettalicness: 0,
    normalScale: 1,
  },
  //endregion

  //#region Concrete3
  {
    id: "Concrete3",
    // color: 0xe1c16e,
    diffuseUrl: "textures/apartment_concrete3_diffuse.jpg",
    normalUrl: "textures/apartment_concrete3_normal.jpg",
    repeat: [2, 2],
    normalRepeat: [2, 2],
    roughnessRepeat: [2, 2],
    mettalicnessRepeat: [2, 2],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 1,
    mettalicness: 0,
    normalScale: 2,
  },
  //endregion

  //#region glass
  {
    id: "Glass",
    color: 0xffffff,
    // diffuseUrl: "textures/apartment_concrete3_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [2, 2],
    normalRepeat: [2, 2],
    roughnessRepeat: [2, 2],
    mettalicnessRepeat: [2, 2],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.9
  },
  //endregion

  //#region acidGlass
  {
    id: "acidGlass",
    color: 0xffffff,
    // diffuseUrl: "textures/apartment_concrete3_diffuse.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [2, 2],
    normalRepeat: [2, 2],
    roughnessRepeat: [2, 2],
    mettalicnessRepeat: [2, 2],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 1,
    mettalicness: 0,
    normalScale: 1,
  },
  //endregion

  //#region Roof
  {
    id: "Roof",
    color: 0x888888,
    diffuseUrl: "textures/apartment_roof_diffuse.jpg",
    normalUrl: "textures/apartment_roof_normal.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [1, 1],
    normalRepeat: [1, 1],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 1,
    mettalicness: 0.1,
    normalScale: 1,
  },
  //endregion

  //#region InnerWall
  {
    id: "InnerWall",
    color: 0xffffff,
    diffuseUrl: "textures/beige_wall_diffuse.jpg",
    normalUrl: "textures/beige_wall_normal.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [10, 10],
    normalRepeat: [10, 10],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 1,
    mettalicness: 0,
    normalScale: 1,
  },
  //endregion

  //#region Ceiling
  {
    id: "Ceiling",
    color: 0xffffcc,
    diffuseUrl: "textures/beige_wall_diffuse.jpg",
    normalUrl: "textures/beige_wall_normal.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [10, 10],
    normalRepeat: [10, 10],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 1,
    mettalicness: 0,
    normalScale: 1,
  },
  //endregion

  //#region Floor
  {
    id: "Floor",
    color: 0xfffffff,
    diffuseUrl: "textures/wood_floor_diffuse.jpg",
    normalUrl: "textures/wood_floor_normal.jpg",
    // normalUrl: "textures/fabric01_normal.jpg",
    repeat: [2, 2],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    roughness: 1,
    mettalicness: 0.1,
    normalScale: 1,
  },
  //endregion

  //#region Bugnet
  {
    id: "Bugnet",
    color: 0xfffffff,
    diffuseUrl: "textures/bugnet_alpha.png",
    alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    // useAlpha: true,
    roughness: 1,
    mettalicness: 0.1,
    normalScale: 1,
    alpha:0.5,
  },
  //endregion

  //#region thermalblind_raven
  {
    id: "thermalblind_raven",
    color: 0x888888,
    diffuseUrl: "textures/thermalblind_raven.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0.5,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region thermalblind_cloud
  {
    id: "thermalblind_coud",
    color: 0xffffff,
    diffuseUrl: "textures/thermalblind_cloud.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region thermalblind_slate
  {
    id: "thermalblind_slate",
    color: 0xcccccc,
    diffuseUrl: "textures/thermalblind_slate.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region thermalblind_desert
  {
    id: "thermalblind_desert",
    color: 0xFDEAD2,
    diffuseUrl: "textures/thermalblind_desert.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region solarshade_dove
  {
    id: "solarshade_dove",
    color: 0xffffff,
    diffuseUrl: "textures/solarshade_dove.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region solarshade_charcoal
  {
    id: "solarshade_charcoal",
    color: 0xffffff,
    diffuseUrl: "textures/solarshade_charcoal.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region solarshade_cocoa
  {
    id: "solarshade_cocoa",
    color: 0xffffff,
    diffuseUrl: "textures/solarshade_cocoa.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region solarshade_apricoat
  {
    id: "solarshade_apricoat",
    color: 0xffffff,
    diffuseUrl: "textures/solarshade_apricoat.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region solarshade_linen
  {
    id: "solarshade_linen",
    color: 0xffffff,
    diffuseUrl: "textures/solarshade_linen.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion

  //#region solarshade_ash
  {
    id: "solarshade_ash",
    color: 0xffffff,
    diffuseUrl: "textures/solarshade_ash.png",
    // alphaUrl: "textures/bugnet_alpha.png",
    repeat: [40, 60],
    normalRepeat: [2, 2],
    roughnessRepeat: [1, 1],
    mettalicnessRepeat: [1, 1],
    useAo: false,
    useRoughness: false,
    useMetallicness: false,
    useAlpha: true,
    roughness: 0.5,
    mettalicness: 0,
    normalScale: 1,
    alpha: 0.95,
  },
  //endregion
]